import FavoritesPage from "./FavoritesPage";
export default FavoritesPage;
